import React from 'react';
import { motion } from 'framer-motion';

const AnimatedEqualizer = ({ color = 'currentColor', size = 16 }) => (
  <div className="flex items-end gap-0.5 h-4" style={{ color }}>
    <motion.div
      animate={{ height: ['40%', '100%', '60%', '80%', '40%'] }}
      transition={{ duration: 0.8, repeat: Infinity, ease: 'easeInOut' }}
      className="w-1 rounded-full"
      style={{ backgroundColor: color, minHeight: '4px' }}
    />
    <motion.div
      animate={{ height: ['100%', '40%', '80%', '60%', '100%'] }}
      transition={{ duration: 0.8, repeat: Infinity, ease: 'easeInOut', delay: 0.2 }}
      className="w-1 rounded-full"
      style={{ backgroundColor: color, minHeight: '4px' }}
    />
    <motion.div
      animate={{ height: ['60%', '80%', '40%', '100%', '60%'] }}
      transition={{ duration: 0.8, repeat: Infinity, ease: 'easeInOut', delay: 0.4 }}
      className="w-1 rounded-full"
      style={{ backgroundColor: color, minHeight: '4px' }}
    />
  </div>
);

export default AnimatedEqualizer;
